"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_MAIN_S_ITEM = exports.DEFAULT_MAIN_T_ITEM = exports.DEFAULT_MENU_S_LIST = exports.DEFAULT_MENU_T_LIST = void 0;
/**
 * 기본 메뉴 리스트 (강사)
 */
exports.DEFAULT_MENU_T_LIST = [
    'learningManagement',
    'learningSupportRoom',
    'notice',
    'liveRoom',
];
/**
 * 기본 메뉴 리스트 (학생)
 */
exports.DEFAULT_MENU_S_LIST = ['liveRoom', 'myRoom', 'learningSupportRoom', 'notice'];
/**
 * 기본 메인 메뉴 기본값 (강사)
 */
exports.DEFAULT_MAIN_T_ITEM = 'home';
/**
 * 기본 메인 메뉴 기본값 (학생)
 */
exports.DEFAULT_MAIN_S_ITEM = 'home';
